module.exports = __webpack_public_path__ + "img/logo-gobiz.2f759a44.svg";